const t = {
  name: "Plus",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 11V3H11V11H3V13H11V21H13V13H21V11H13Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Plus
};
